import { Box } from '@mui/material';
import { z } from 'zod';

import Heading from '@/features/Dashboard/components/Heading';
import { SPOT_HISTORY_TABLE_MAX_ITEMS } from '@/features/Dashboard/constants/const';
import { DrawerStep } from '@/features/Dashboard/drawer/types';
import { ItemSelection } from '@/features/Dashboard/form/AppForm/components/ItemSelection';
import { TabName } from '@/features/Dashboard/form/AppForm/components/TabName';
import type { SpotHistoryTableValues } from '@/features/Dashboard/form/AppForm/context/types';
import type { SpotHistoryTableWidgetV2 } from '@/features/Dashboard/types';
import { AppType } from '@/features/Dashboard/types';

import type { FormAppDefinition } from '../types';
import {
  buildSpotHistoryTable,
  NameSchema,
  SymbolsStateSchema,
  tableToFormValues
} from './_helpers';

export const spotHistoryTableDefinition: FormAppDefinition<
  SpotHistoryTableValues,
  SpotHistoryTableWidgetV2
> = {
  type: AppType.SpotHistoryTable,
  drawerStep: DrawerStep.SpotHistoryTable,
  dashboardControls: { edit: true },
  widgetControls: { export: true },
  maxItems: SPOT_HISTORY_TABLE_MAX_ITEMS,
  initialValues: {
    name: 'Spot History Table',
    type: AppType.SpotHistoryTable,
    symbols: { active: [], backlog: [] }
  },
  schema: z.object({
    id: z.string().optional(),
    type: z.literal(AppType.SpotHistoryTable),
    name: NameSchema,
    symbols: SymbolsStateSchema
  }),
  Form: () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Heading
        subtitle='Set up your table preferences and data'
        title='Configure spot history table'
      />
      <TabName />
      <ItemSelection />
    </Box>
  ),
  toWidget: values => buildSpotHistoryTable(values.name, values.symbols, values.id),
  canEditWidget: (w): w is SpotHistoryTableWidgetV2 => w.type === 'spothistorytable',
  fromWidget: w => tableToFormValues(w, AppType.SpotHistoryTable)
};
